<template>
  <div class="shoppe">
    <div class="query-form">
      <el-form label-position="right" label-width="80px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="买手店">
                  <BrandSelect :data="vendorList" v-model="queryForm.vendorId" filterable></BrandSelect>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="品牌">
                  <BrandSelect :data="brandList" v-model="queryForm.brandId" clearable filterable></BrandSelect>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="货号">
                  <el-input v-model="queryForm.designerId" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="色号">
                  <el-input v-model="queryForm.colorCode" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="时间">
                  <el-date-picker
                    v-model="daterange"
                    type="daterange"
                    value-format="timestamp"
                    :default-time="['00:00:00', '23:59:59']"
                    :picker-options="pickerOptions"
                    @blur="onDateBlur"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="错误码">
                  <el-select v-model="queryForm.codeIds" filterable clearable>
                    <el-option v-for="item in errorCodeList" :key="item.code" :label="item.codeName" :value="item.code"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="处理标记">
                  <el-select v-model="queryForm.draftTag" clearable>
                    <el-option label="有" :value="1"></el-option>
                    <el-option label="无" :value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button @click="search" type="primary">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="tool-bar">
      <div>
        <el-button type="primary" :disabled="selections.length == 0" @click="handleBatchProcess(selections)">批量处理</el-button>
      </div>
      <el-dropdown @command="handleExport" :disabled="exportLoading">
        <el-button plain type="primary" :loading="exportLoading">导出<i class="el-icon-arrow-down"></i></el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="comma">CSV (Comma)</el-dropdown-item>
          <el-dropdown-item command="semicolon">CSV (Semicolon)</el-dropdown-item>
          <el-dropdown-item command="excel">Excel</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <el-table :data="tableData" v-loading="loading" @selection-change="tableSelectionChange" @sort-change="sortChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="" width="100" class-name="nopadding">
        <template slot-scope="scope">
          <list-img :img="scope.row.images" :width="80"></list-img>
        </template>
      </el-table-column>
      <el-table-column prop="brandName" label="商品信息" min-width="130">
        <template slot-scope="scope">
          <div class="product-cell">
            <p class="">{{ scope.row.brandName }}</p>
            <p class="mt10">{{ scope.row.productName }}</p>
            <p class="mt10 keep-space">
              <span class="label">货号: </span>{{ scope.row.designerId }}
            </p>
            <p class="keep-space">
              <span class="label">颜色: </span>{{ scope.row.colorCode }}
            </p>
            <div class="signet" v-if="scope.row.draftTag === 0">未处理</div>
            <div class="signet light" v-if="scope.row.draftTag === 1">已处理</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="vendorId" label="买手店">
        <template slot-scope="scope">
          {{ vendorNameMap[scope.row.vendorId] }}
        </template>
      </el-table-column>
      <el-table-column prop="boutiqueSeasonCode" label="季节">
        <template slot-scope="scope">
          {{ scope.row.boutiqueSeasonCode }}{{ scope.row.coFlag === 1 ? '(CO)' : '' }}
        </template>
      </el-table-column>
      <el-table-column prop="categoryPath" label="类目"></el-table-column>
      <el-table-column prop="stock" label="库存"></el-table-column>
      <el-table-column prop="errorCode" label="错误码" min-width="150">
        <template slot-scope="scope">
          <template v-if="scope.row.errorCodeFold">
            <p>{{ scope.row.errorCode }}</p>
          </template>
          <template v-else>
            <p v-for="(item, index) in scope.row.errorCodeList" :key="index">{{ item }}</p>
          </template>
          <el-link v-if="scope.row.errorCount > 1 && scope.row.errorCodeFold" type="primary" @click="loadErrorCodeList(scope)"
            >全部({{ scope.row.errorCount }})</el-link
          >
          <el-link v-if="!scope.row.errorCodeFold" type="primary" @click="foldErrorCodeList(scope)">收起</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="createdTime" label="创建时间">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.createdTime) }}
        </template>
      </el-table-column>
      <el-table-column prop="updatedTime" label="更新时间">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.updatedTime) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-link type="primary" @click="openEdit(scope.row)">编辑</el-link>
          <el-link class="ml10" type="primary" @click="handleBatchProcess([scope.row])">处理</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <el-dialog append-to-body title="编辑SKU" :visible.sync="dialogVisible" width="1000px" :close-on-click-modal="false">
      <div class="mb10">
        <span class="label">货号：</span><span class="value">{{ currProduct.designerId }}</span>
        <span class="label">颜色：</span><span class="value">{{ currProduct.colorCode }}</span>
        <span class="label">品牌：</span><span class="value">{{ currProduct.brandName }}</span>
        <span class="label">季节：</span><span class="value">{{ currProduct.boutiqueSeasonCode }}</span>
        <span class="label">类目：</span><span class="value">{{ currProduct.categoryPath }}</span>
      </div>
      <el-table :data="skuList" v-loading="skuListLoading" :header-cell-style="{background:'#F4F5F6'}">
        <el-table-column prop="skuCode" label="SKU编码">
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.skuCode" :maxlength="50" size="mini" />
          </template>
        </el-table-column>
        <el-table-column prop="sizeStandard" label="尺码标准">
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.sizeStandard" :maxlength="20" size="mini" />
          </template>
        </el-table-column>
        <el-table-column prop="size" label="尺码">
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.size" :maxlength="20" size="mini" />
          </template>
        </el-table-column>
        <el-table-column prop="retailPrice" label="吊牌价">
          <template slot="header" slot-scope="{}">
            <template v-if="currProduct.isPriceWhiteList">
              吊牌价<br />
              <span class="f12">({{ currProduct.originalPriceUnit }}/{{ currProduct.retailPriceIncludingTax === 1 ? '含税' : '不含税' }})</span>
            </template>
            <template v-else>
              吊牌价({{ currProduct.originalPriceUnit }})
            </template>
          </template>
          <template slot-scope="scope">
            <el-input type="number" v-model.number="scope.row.retailPrice" :min="0" :max="9999999999" :disabled="currProduct.provideRetailPrice === 2" @change="keyUpKeyboard" size="mini"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="supplyPrice" label="供货价" v-if="currProduct.supplyPriceMethod === 1">
          <template slot="header" slot-scope="{}">
            <template v-if="currProduct.isPriceWhiteList">
              供货价<br />
              <span class="f12">({{ currProduct.originalPriceUnit }}/{{ currProduct.includingTax === 1 ? '含税' : '不含税' }})</span>
            </template>
            <template v-else>
              供货价({{ currProduct.originalPriceUnit }})
            </template>
          </template>
          <template slot-scope="scope">
            <el-input type="number" v-model.number="scope.row.supplyPrice" :min="0" :max="9999999999" @change="keyUpKeyboard" size="mini"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="costPrice" :label="`成本价(${ currProduct.originalPriceUnit })`" v-if="currProduct.supplyPriceMethod === 2">
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.costPrice" :maxlength="9" @change="changeCostPrice" size="mini"> </el-input>
          </template>
        </el-table-column>
        <el-table-column prop="stock" label="库存">
          <template slot-scope="scope">
            <el-input type="number" v-model.number="scope.row.stock" :min="0" :max="99999999" size="mini" />
          </template>
        </el-table-column>
        <el-table-column prop="desc">
          <template slot-scope="scope">
            <i class="el-icon-warning" style="color: #ff0000" v-if="scope.row.desc"></i>
            {{ scope.row.desc }}
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <!-- <el-button type="primary" @click="submitForm('save')">保存</el-button> -->
        <el-button type="primary" @click="submitForm('update')">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { startOfDay, endOfDay, addDays } from 'date-fns';
import utils from '@/utils/util';
import {
  queryVendorList,
  getErrorCodeList,
  getSKUDraftsProductList,
  draftsProductMarkTag,
  queryBoutiqueErrorByBoutiqueProductId,
  exportDraftsProduct,
  getSKUDraftProductInfo,
  updateSKUDraft,
  saveSKUDraft,
} from '../../api/mapping';
import {
  getBrandList,
} from '../seller/api';
import BrandSelect from '../shared/brandSelect.vue';
import ListImg from '../shared/ListImg.vue';

export default {
  components: {
    BrandSelect,
    ListImg,
  },
  data() {
    return {
      loading: false,
      vendorList: [],
      vendorNameMap: {},
      brandList: [],
      errorCodeList: [],
      daterange: [],
      queryForm: {
        vendorId: null,
        brandId: null,
        designerId: null,
        colorCode: null,
        codeIds: null,
        draftTag: null,
        pageNo: 1,
        pageSize: 25,
        orderBy: null,
        desc: null,
      },
      tableData: [],
      total: 0,
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          // 记录第一次点击的时间。
          this.firstDate = maxDate || minDate;
        },
        disabledDate: (time) => {
          // 超过前后90天禁用
          if (this.firstDate) {
            return (
              time > new Date(this.firstDate.getTime() + 24 * 60 * 60 * 1000 * 365) ||
              time < new Date(this.firstDate.getTime() - 24 * 60 * 60 * 1000 * 365)
            );
          }
          return false;
        },
      },
      selections: [],
      exportLoading: false,
      dialogVisible: false,
      currProduct: {
        designerId: null,
        colorCode: null,
        brandName: null,
        boutiqueSeasonCode: null,
        categoryPath: null,
        retailPriceIncludingTax: null,
        includingTax: null,
        originalPriceUnit: null,
        supplyPriceMethod: null,
        isPriceWhiteList: null,
        provideRetailPrice: null,
        costRetailPriceCoefficient: null,
        skuCodeUnique: null,
      },
      skuList: [],
      skuListLoading: false,
    };
  },
  created() {
    queryVendorList().then(res => {
      if (res.data && res.data.data) {
        const map = {};
        this.vendorList = res.data.data.map(item => {
          map[item.vendorId] = item.vendorName;
          return {
            label: item.vendorName,
            value: item.vendorId,
          }
        });
        this.vendorNameMap = map;
      }
    });
    getBrandList().then(res => {
      if (res.data) {
        this.brandList = res.data.map(item => ({
          label: item.englishName,
          value: item.brandId,
        }));
      }
    })
    getErrorCodeList().then(res => {
      if (res.data && res.data.data) {
        this.errorCodeList = res.data.data;
      }
    })
    this.setDefaultDate();
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.vendorId = null;
      this.queryForm.brandId = null;
      this.queryForm.designerId = null;
      this.queryForm.colorCode = null;
      this.queryForm.codeIds = null;
      this.queryForm.draftTag = null;
      this.setDefaultDate();
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    setDefaultDate() {
      const startTime = startOfDay(addDays(new Date(), -90)).getTime();
      const endTime = endOfDay(new Date()).getTime();
      this.daterange = [startTime, endTime];
    },
    getTableData() {
      getSKUDraftsProductList({
        ...this.queryForm,
        codeIds: this.queryForm.codeIds ? [this.queryForm.codeIds] : null,
        startCreatedAt: this.daterange[0] || null,
        endCreatedAt: this.daterange[1] || null,
      }).then(res => {
        if (res.data && res.data.data) {
          this.total = res.data.data.total;
          this.tableData = (res.data.data.list || []).map((item) => {
            const temp = [];
            if (item.category1Name) {
              temp.push(item.category1Name);
            }
            if (item.category2Name) {
              temp.push(item.category2Name);
            }
            if (item.category3Name) {
              temp.push(item.category3Name);
            }
            item.categoryPath = temp.join('>');
            item.errorCodeFold = true;
            item.errorCodeList = [];
            return item;
          });
        }
      })
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    tableSelectionChange(selections) {
      this.selections = selections;
    },
    onDateBlur() {
      this.firstDate = null;
    },
    dateFormat(time) {
      if (!time) {
        return '';
      }
      return utils.dateFormat(new Date(time), 'yyyy-MM-dd hh:mm:ss');
    },
    sortChange({ prop, order }) {
      if (order) {
        this.queryForm.orderBy = prop;
        this.queryForm.desc = order === 'descending';
      } else {
        this.queryForm.orderBy = null;
        this.queryForm.desc = null;
      }
      this.getTableData();
    },
    handleExport(command) {
      switch (command) {
        case 'comma':
          this.exportCSVOrExcel(1);
          break;
        case 'semicolon':
          this.exportCSVOrExcel(2);
          break;
        case 'excel':
          this.exportCSVOrExcel(1, 2);
          break;
        default:
          break;
      }
    },
    exportCSVOrExcel(exportType) {
      this.exportLoading = true;
      exportDraftsProduct({
        ...this.queryForm,
        codeIds: this.queryForm.codeIds ? [this.queryForm.codeIds] : null,
        startCreatedAt: this.daterange[0] || null,
        endCreatedAt: this.daterange[1] || null,
        exportType,
      }).then((res) => {
        this.exportLoading = false;
        if (res.data && res.data.success) {
          this.$confirm('导出任务已创建', '提示', {
            confirmButtonText: '去查看',
            cancelButtonText: '完成',
            type: 'warning'
          }).then(() => {
            this.$router.push({ path: '/taskManage' });
          }).catch(() => {         
          });
        } else {
          if (res.data.code === 1 || res.data.code === '1') {
            res.data.message = '导出中，请稍后再试';
          }
          this.$message.error(res.data.message || '系统异常，请稍后再试');
        }
      });
    },
    handleBatchProcess(selections) {
      if (selections.length === 0) {
        return;
      }
      this.$confirm('是否继续操作', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const ids = selections.map((item) => item.boutiqueProductId);
        draftsProductMarkTag(ids).then((res) => {
          if (res.data && res.data.success) {
            this.$message.success('操作成功');
            this.getTableData();
          } else {
            this.$message.error(res.data.message || '系统异常，请稍后再试');
          }
        });
      });
    },
    loadErrorCodeList(scope) {
      if (this.tableData[scope.$index].errorCodeList.length > 0) {
        this.tableData[scope.$index].errorCodeFold = false;
        return;
      }
      queryBoutiqueErrorByBoutiqueProductId({
        boutiqueProductId: scope.row.boutiqueProductId,
      }).then((res) => {
        if (res.data && res.data.success) {
          this.tableData[scope.$index].errorCodeFold = false;
          this.tableData[scope.$index].errorCodeList = res.data.data || [];
        } else {
          this.$message.error(res.data.message || '系统异常，请稍后再试');
        }
      });
    },
    foldErrorCodeList(scope) {
      this.tableData[scope.$index].errorCodeFold = true;
    },
    openEdit(row) {
      this.currProduct = row;
      this.skuList = [];
      this.skuListLoading = true;
      getSKUDraftProductInfo(row.boutiqueProductId).then(res => {
        if (res.data && res.data.success) {
          const temp = [];
          if (res.data.data.category1Name) {
            temp.push(res.data.data.category1Name);
          }
          if (res.data.data.category2Name) {
            temp.push(res.data.data.category2Name);
          }
          if (res.data.data.category3Name) {
            temp.push(res.data.data.category3Name);
          }
          res.data.data.categoryPath = temp.join('>');
          this.currProduct = res.data.data;
          this.skuList = (res.data.data.skuList || []).map(item => ({
            ...item,
            desc: '',
          }));
        } else {
          this.$message.error(res.data.message || '系统异常，请稍后再试');
        }
        this.skuListLoading = false;
      })
      this.dialogVisible = true;
    },
    submitForm(type) {
      if (this.skuList.some(item => item.desc)) {
        this.$message.error('请先处理错误信息');
        return;
      }
      if (this.currProduct.skuCodeUnique && this.skuList.some(item => !item.skuCode.trim())) {
        this.$message.error('SKU编码必填');
        return;
      }
      if (this.skuList.some(item => !item.size)) {
        this.$message.error('尺码必填');
        return;
      }
      if (this.skuList.some(item => item.retailPrice == null || item.retailPrice == '')) {
        this.$message.error('吊牌价必填');
        return;
      }
      if (this.currProduct.supplyPriceMethod == 1 && this.skuList.some(item => item.supplyPrice == null || item.supplyPrice == '')) {
        this.$message.error('供货价必填');
        return;
      }
      if (this.currProduct.supplyPriceMethod == 2 && this.skuList.some(item => item.costPrice == null || item.costPrice == '')) {
        this.$message.error('成本价必填');
        return;
      }
      if (this.repeatSave) {
        return;
      }
      this.repeatSave = true;
      let request = updateSKUDraft;
      if (type === 'save') {
        request = saveSKUDraft;
      }
      request(this.skuList).then(res => {
        if (res.data && res.data.success) {
          this.$message.success(type === 'save' ? '已保存' : '提交成功');
          this.dialogVisible = false;
          this.getTableData();
        } else {
          this.$message.error(res.data.message || '系统异常，请稍后再试');
        }
        setTimeout(() => {
          this.repeatSave = false;
        }, 3000); 
      }).catch(() => {
        setTimeout(() => {
          this.repeatSave = false;
        }, 3000); 
      })
    },
    keyUpKeyboard() {
      this.skuList.map((item) => {
        if (Number(item.supplyPrice) > Number(item.retailPrice)) {
          item.desc = '当前供货价大于吊牌价';
        } else {
          item.desc = '';
        }
        return item;
      });
    },
    changeCostPrice() {
      this.skuList.map((item) => {
        if (this.currProduct.provideRetailPrice === 2) {
          if (item.costPrice === null || item.costPrice === '') {
            item.retailPrice = '';
          } else {
            item.retailPrice = (item.costPrice * this.currProduct.costRetailPriceCoefficient).toFixed(2);
          }
        } else if (parseFloat(item.costPrice) > parseFloat(item.retailPrice)) {
          item.desc = '当前成本价大于吊牌价';
        } else {
          item.desc = '';
        }
        return item;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.mb10 {
  margin-bottom: 10px;
}
.ml10 {
  margin-left: 10px;
}
.tool-bar {
  display: flex;
  justify-content: space-between;
}
.product-cell {
  position: relative;
  // z-index: 10;

  .signet {
    position: absolute;
    top: 20px;
    left: 20px;
    padding: 2px 12px;
    color: #999;
    font-weight: 600;
    border: 2px solid #999;
    border-radius: 2px;
    transform: rotate(-25deg);
    opacity: 0.4;
    pointer-events: none;
    // z-index: 9;

    &::after {
      content: "";
      position: absolute;
      top: 2px;
      right: 2px;
      bottom: 2px;
      left: 2px;
      border: 1px solid #999;
    }
    &.light {
      color: red;
      border-color: red;

      &::after {
        border-color: red;
      }
    }
  }
}
.value {
  font-weight: bold;
}
.value + .label {
  margin-left: 20px;
}
</style>
